const SvgComponent = () => (
  <svg width={110} height={113} fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_5184_37204)">
      <mask
        id="mask0_5184_37204"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={28}
        width={73}
        height={21}
      >
        <path
          d="M84.927 28.2719L57.343 43.53L48.8585 48.3188L48.8342 48.3337L42.1318 47.9283L12.0087 46.3777L43.8584 31.9353L84.927 28.2719Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_5184_37204)">
        <path
          d="M84.9715 28.23L57.3309 43.4795L48.8286 48.2651L48.8042 48.28L42.1017 47.8975L11.9772 46.4479L43.8818 31.9961L84.9715 28.23Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.4617 47.3126L61.7004 92.2037L61.6709 92.2021L35.7069 91.5246L15.9208 50.3791L41.9839 47.9225L48.4334 47.3153L48.4617 47.3126Z"
        fill="#DD3F49"
      />
      <mask
        id="mask1_5184_37204"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={48}
        y={31}
        width={43}
        height={62}
      >
        <path
          d="M62.8395 92.3745L90.6972 74.8022L81.2575 31.852L48.6479 46.2993L62.8395 92.3745Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_5184_37204)">
        <path
          d="M62.6271 92.3424L90.7315 74.6794L81.4699 31.8839L48.6043 46.4529L62.6271 92.3424Z"
          fill="white"
        />
      </g>
      <mask
        id="mask2_5184_37204"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={11}
        y={27}
        width={78}
        height={33}
      >
        <path
          d="M84.6041 27.9706L88.0938 42.9376L84.6283 44.5556L52.2669 59.6622L52.2382 59.6626L20.8932 59.5751L16.6376 59.5647L11.9272 45.8968L47.38 43.7439L84.6041 27.9706Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_5184_37204)">
        <path
          d="M84.7049 27.9681L88.1362 42.8285L84.6617 44.4492L52.2153 59.5813L52.1866 59.5818L20.8191 59.6111L16.5604 59.6166L11.9021 46.0517L47.3895 43.7808L84.7049 27.9681Z"
          fill="#EDEDED"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.4857 43.9986L61.7017 92.2037L35.6942 91.5414L20.4434 59.8542L16.1636 59.9456L11.7744 46.9136L47.4857 43.9986Z"
        fill="#D2D2D2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.9552 59.1581L53.3897 64.0224L23.0189 65.5042L20.2421 59.7321L51.9552 59.1581Z"
        fill="#B4B4B4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.9564 59.1578L84.9303 43.7807L86.0064 49.1359L53.3909 64.022L51.9564 59.1578Z"
        fill="#CDCCC7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4666 24.6825C29.4666 24.6825 26.7402 29.0005 30.8271 32.3387C33.8037 34.7702 44.9272 37.4477 44.9272 37.4477L43.0808 37.9922C43.0808 37.9922 31.9103 39.1062 25.6014 34.4251C19.2933 29.7438 22.3169 20.9157 29.4666 24.6825Z"
        className="fill-(--ribbon-2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.2465 37.9439C43.2465 37.9439 19.9565 37.3125 24.0393 26.6416C27.543 17.4867 45.0922 37.3996 45.0922 37.3996L48.9537 36.2608C48.9537 36.2608 38.9218 7.81324 24.6971 19.5891C15.6919 27.044 24.8236 42.2937 43.2465 37.9439Z"
        className="fill-(--ribbon-1)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.6411 16.9462C54.6411 16.9462 59.2743 19.0937 57.6525 24.1144C56.4709 27.773 48.5811 36.0575 48.5811 36.0575L50.4275 35.513C50.4275 35.513 60.4147 30.3866 63.1741 23.0313C65.9325 15.6763 58.6026 9.90184 54.6411 16.9462Z"
        className="fill-(--ribbon-2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.4657 35.1899C50.4657 35.1899 69.6857 22.021 60.4663 15.274C52.5554 9.4844 48.62 35.7342 48.62 35.7342L44.7586 36.873C44.7586 36.873 37.7489 7.53412 56.0879 9.70675C67.696 11.0817 68.3006 28.847 50.4657 35.1899Z"
        className="fill-(--ribbon-1)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.1463 37.3659L25.5186 45.8241L30.4184 59.6878L41.645 91.7455L50.8245 91.9721L36.0833 45.9101L48.0069 36.2274L44.1463 37.3659Z"
        className="fill-(--ribbon-1)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.3086 37.4683L61.9067 37.3539L74.5234 84.0455L82.2253 79.2921L74.106 45.8582L70.6981 31.5612L50.5352 34.5441L44.3086 37.4683Z"
        className="fill-(--ribbon-1)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.3663 59.3149L42.0621 64.5774L32.2933 65.0255L30.3636 59.5425L40.3663 59.3149Z"
        className="fill-(--ribbon-2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.0296 52.6013L74.7522 48.5251L76.0124 53.6992L67.3868 57.6403L66.0296 52.6013Z"
        className="fill-(--ribbon-2)"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5184_37204"
        x={-5.00012}
        y={-0.000732422}
        width={119.898}
        height={122.22}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5184_37204"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5184_37204"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export { SvgComponent as GiftBanner }
